





















import { Vue, Prop, Component } from 'vue-property-decorator';
import { FieldMetadata } from 'private_modules/performo-api/dist/models';

@Component({})
export default class ExtendedDataPicker extends Vue {
  @Prop({ required: true })
  private metadata!: FieldMetadata[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({
    required: true,
    default: () => {
      return {};
    }
  })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private value: { [key: string]: any } = {};

  private async handleExtendedDataChange(name: string, extendedData: string) {
    // perform api call
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newExtendedData: { [key: string]: any } = {
      ...this.value,
      [name]: extendedData
    };
    this.$emit('input', newExtendedData);
  }
}
